// extracted by mini-css-extract-plugin
export default {"a11yFocus":"BeYsAN","a11YFocus":"BeYsAN","submitButton":"_S6sGf","form":"XSbmzA","methods":"ni_Wjh","methodButton":"LatNZz","errorText":"JYeZWc","wixel":"tBOFmP"};